const doc = [({"da":({"js":({"nemoa":({"activities":({"show":({"politics":({"politics":"Politik"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;